import apple from '../../Assets/landing/apple.png'
import android from '../../Assets/landing/google.png'
import { trackEvent } from '../../Analytics/trackEvent'

export const APP_STORE_URL = 'https://apps.apple.com/uk/app/first-dance/id6739738754'
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.firstdance.firstdance'

/** App Store / Google Play download badges with GA click tracking. */
export default function StoreBadges({ className = 'app-icon', style }) {
    return (
        <div style={style}>
            <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noreferrer"
                onClick={() => trackEvent('app_store_click', { platform: 'ios' })}
            >
                <img
                    className={className}
                    style={{ marginRight: 20 }}
                    src={apple}
                    alt="Download the First Dance wedding planning app on the Apple App Store UK"
                />
            </a>
            <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noreferrer"
                onClick={() => trackEvent('app_store_click', { platform: 'android' })}
            >
                <img
                    className={className}
                    src={android}
                    alt="Download the First Dance wedding planner app on Google Play UK"
                />
            </a>
        </div>
    )
}
